import { useGlobal } from '../contexts/GlobalContext';


function CreatorCard({ image, name, location, description, shopLink, logo, instagramLink, creatorId, products }) {
  const { t, parse } = useGlobal();
  const iUrl = import.meta.env.VITE_DIRECTUS_PUBLIC_URL + "/assets/"

  // Filter products for this creator

  const creatorProducts = products?.filter(product => product.creator_id === creatorId).slice(0, 8) || [];

  return (
    <div className="creator-card bg-white shadow-lg overflow-hidden w-full lg:w-[70%] mx-auto">
      <div className="creator-card__container flex flex-col lg:grid lg:grid-cols-5">
        {/* Image Section - Full width on mobile, 20% on desktop */}
        <div className="creator-card__image-wrapper lg:col-span-1 h-[600px] lg:h-auto">
          <img
            src={`${iUrl}${image}?format=webp`}
            alt={name}
            className="creator-card__image w-full h-full object-cover"
          />
        </div>

        {/* Content Section - Full width on mobile, 80% on desktop */}
        <div className="creator-card__content lg:col-span-4 p-8 flex flex-col justify-center">
          <div className="creator-card__content-head flex flex-col lg:flex-row lg:items-start lg:justify-between mb-3">
            <div className="flex-1">
              {shopLink ? (
                <a
                  href={shopLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="creator-card__title-link block transition-opacity hover:opacity-60"
                >
                  <h3 className="font-light creator-card__title font-family-header text-3xl text-dark-900 mb-2">
                    {name}
                  </h3>
                </a>
              ) : (
                <h3 className="font-light creator-card__title font-family-header text-3xl text-dark-900 mb-2">
                  {name}
                </h3>
              )}
              <p className="creator-card__location font-body text-sm text-dark-500">
                {location}
              </p>
            </div>

            {/* Social Links Box */}
            <div className="creator-card__links-box flex flex-col gap-2 mt-3 lg:mx-4 lg:mt-0">
              {instagramLink && (
                <a
                  href={instagramLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="creator-card__instagram flex items-center gap-2 transition-opacity hover:opacity-60"
                  aria-label={`${name} Instagram`}
                >
                  <svg className="w-5 h-5 fill-dark-900 flex-shrink-0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                  <span className="font-body text-sm text-dark-900">Instagram</span>
                </a>
              )}
              {shopLink && (
                <a
                  href={shopLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="creator-card__website flex items-center gap-2 transition-opacity hover:opacity-60"
                >
                  <svg className="w-5 h-5 fill-dark-900 flex-shrink-0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"/>
                  </svg>
                  <span className="font-body text-sm text-dark-900">{shopLink}</span>
                </a>
              )}
            </div>

            {logo && (
              <div className="creator-card__logo-wrapper flex-shrink-0 mt-3 lg:mt-0">
                <img
                  src={`${iUrl}${logo}?format=webp`}
                  alt={`${name} logo`}
                  className="creator-card__logo w-16 h-16 object-contain"
                />
              </div>
            )}
          </div>
          <div className="creator-card__divider w-full h-px bg-gray-300 mb-3"></div>
          <div className="creator-card__description font-body text-dark-700 leading-relaxed">
            {parse(description)}
          </div>

          {/* Products Section */}
          {creatorProducts.length > 0 && (
            <div className="creator-card__products-section mt-6 pt-6 border-t border-gray-300">
              <h4 className="font-family-header font-light text-2xl text-dark-900 mb-4">
                {t("support_creator")}
              </h4>
              <div className="creator-card__products-grid grid grid-cols-4 gap-3 w-full">
                {creatorProducts.map((product) => (
                  <div key={product.id} className="creator-card__product-item flex flex-col">
                    <a
                      href={product.product_shop_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="creator-card__product-image-wrapper h-40 mb-2 overflow-hidden bg-gray-100 rounded block"
                    >
                      <img
                        src={`${iUrl}${product.product_image}?format=webp`}
                        alt={product.product_name}
                        className="w-full h-full object-cover transition-transform duration-300 ease-out hover:scale-105"
                      />
                    </a>
                    <h5 className="font-body font-medium text-sm text-dark-900 line-clamp-2">
                      {product.product_name}
                    </h5>
                    <p className="font-body text-sm font-semibold text-dark-700 mt-1">
                      €{product.product_price.toFixed(2)}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CreatorCard
